module.exports = __webpack_public_path__ + "resources/img/img_tibero_m_jp.5d44de7548ae2cd5a6df80ca961e84f0.png";